import React from "react";
import { useTranslation } from "react-i18next";
import { Offer } from "../../../types/modules/offer.type";
import OfferListItem from "./OfferListItem";
import { PermissionGate } from "../../admin/PermissionGate";
import { PermissionsKey } from "../../../data/permissions";

interface Props {
  offers: Offer[];
  storeId?: number;
}

const OfferListTable: React.FC<Props> = ({ offers, storeId }) => {
  const { t } = useTranslation();

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-separate border-spacing-y-5">
        <thead>
          <tr className="text-start text-sm capitalize text-DarkGrey2 font-semibold">
            <th className="p-3 font-normal">{t("offer_table.offer_name")}</th>
            <th className="p-3 font-normal">{t("offer_table.offer_products")}</th>
            <th className="p-3 font-normal">{t("offer_table.offer_date")}</th>
            <th className="p-3 font-normal">{t("offer_table.type")}</th>
            <th className="p-3 font-normal">{t("offer_table.used")}</th>
            <th className="p-3 font-normal">{t("offer_table.status")}</th>
            {
            storeId && 
            <PermissionGate permissions={[PermissionsKey.UpdateOffer]}>
              <th className="p-3 font-normal">{t("active")}</th>
              </PermissionGate>
            }
          </tr>
        </thead>
        <tbody className="text-sm">
          {offers.map((offer) => (
            <OfferListItem key={offer.id} offer={offer} storeId={storeId} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OfferListTable;
